const setLoadingState = (form, disable = true) => {
  let $submit_button = $(form).find('button[type="submit"]');
  $submit_button = $submit_button.length ? $submit_button : $(form).find('input[type="submit"]');

  if (disable) {
    $submit_button.prop('disabled', true);
  } else {
    $submit_button.prop('disabled', false);
  }
};

const sendWebForm = (data) => {
  const url = `${window.theme.sh_webform_url}`;
  return $.post({
    url,
    data,
    async: true,
    cache: false,
    contentType: false,
    enctype: 'multipart/form-data',
    processData: false,
    crossDomain: true,
  });
};

const setBindings = ($container) => {
  $('[data-business-contact-us-form]', $container).submit((e) => {
    e.preventDefault();
    setLoadingState(e.currentTarget);

    const form_data = new FormData(e.currentTarget);

    sendWebForm(form_data)
      .then((response) => {
        $('.validation-advice').hide();
        setLoadingState(e.currentTarget, false);
        if (response.success !== '') {
          // const $modal = $('#webForm').closest('.modal-inner-wrap');
          // $modal.find('.modal-title').hide();
          // $modal.find('.modal-footer').hide();
          $('html, body').animate({ scrollTop: 0 }, 'slow');
          $('#block1').hide();
          $('#block2').html(response.success);
          $('#block2').show();
          $('.successBlock').show();
        } else {
          if (response.error_email !== '') {
            $('#error_email').html(response.error_email);
            $('#error_email').show();
          }
          if (response.error_firstName !== '') {
            $('#error_firstName').html(response.error_firstName);
            $('#error_firstName').show();
          }
          if ($('.please-wait').length) {
            $('.please-wait').hide();
          }
          $('button').removeClass('link_clicked');
          if ($('#submitForm').length) {
            $('#submitForm').removeAttr('disabled');
          }
        }
        return true;
      })
      .catch((error) => console.log(error));
  });
};

const init = ($container = $(document)) => {
  console.log('Business Contact Us init');

  setBindings($container);
};
init();
